<div class="flex flex-col gap-1 w-full relative">
    <label class="flex items-center justify-between mb-1">
        <div class="text-sm font-normal text-gray-900 leading-none tracking-normal">{{lebal}} <span *ngIf="is_required" class="text-red-500">*</span></div>
        <span *ngIf="accept.includes('.csv') || accept.includes('.xlsx')" (click)="downloadTemplate()" class="text-[#3F41D1] font-medium text-sm leading-none tracking-normal cursor-pointer ml-2">Download Template</span>

    </label>

    <div class="flex flex-col gap-2">
        <!-- Box-style Photo Upload (Image only) -->
        <label *ngIf="uploaderVariant === 'photo-box' && (multiple || images.length === 0) && (accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp'))" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" class="flex items-center justify-center w-full rounded-2xl transition-all duration-200 bg-[#EBF2FF]" [ngClass]="[box_aspect, isDragging ? 'bg-[#d5e8fc]' : '', box_clickable ? 'cursor-pointer' : 'pointer-events-none']">
            <input #photoBoxInput [disabled]="disabled || paramValue.view == 'true'" [accept]="accept" type="file" [multiple]="multiple" (change)="onImageSelected($event)" class="hidden" />

            <!-- Landscape icon -->
            <ng-container *ngIf="box_icon === 'landscape'">
                <img src="../../../assets/image-placeholder.png" class="w-full h-full object-cover rounded-2xl" alt="Image Placeholder">
            </ng-container>

            <!-- Person avatar icon -->
            <ng-container *ngIf="box_icon === 'person'">
                <img src="../../../assets/profile-placeholder.png" class="w-full h-full object-cover rounded-2xl" alt="Profile Placeholder">
            </ng-container>
        </label>

        <!-- Minimal Upload Button -->
        <label *ngIf="uploaderVariant !== 'photo-box' && (multiple || images.length === 0)" class="flex items-center justify-start px-4 py-3 bg-white border border-gray-300 cursor-pointer hover:bg-gray-50 transition-all duration-200 group rounded-lg shadow-md">
            <input [disabled]="disabled || paramValue.view == 'true'" [accept]="accept" type="file" [multiple]="multiple" (change)="onImageSelected($event)" class="hidden" />
            <div class="flex flex-col items-center gap-1 text-gray-600]">
                <div class="flex items-center gap-2">
                    <!-- <i class='bx bx-cloud-upload text-xl'></i> -->
                    <img src="../../../assets/Upload_icon.svg" alt="">
                    <span class="text-sm font-medium">Choose {{ accept.includes('image') ? 'Image' : 'File' }} To Upload</span>
                    <span class="text-[0.65rem] text-gray-400">(Supported: {{ accept }}, Max: {{ maxFileSize }}MB)</span>
                </div>
            </div>
        </label>

        <!-- Photo Box Preview -->
        <div *ngIf="uploaderVariant === 'photo-box' && images.length > 0" class="grid grid-cols-1 gap-4 w-full">
            <div *ngFor="let img of images; let i = index" class="relative w-full lg:w-fit">
                <div class="w-full lg:w-[192px] h-[230px] rounded-[9.2px] bg-[#EBF2FF] overflow-hidden shadow-[0px_2px_6px_2px_#00000026,0px_1px_2px_0px_#0000004D]" (click)="view_image(i)">
                    <img *ngIf="accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp')" [src]="img" class="w-full h-full object-cover cursor-pointer">
                    <div *ngIf="!(accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp'))" class="w-full h-full flex items-center justify-center">
                        <i class='bx bx-file text-gray-500 text-4xl'></i>
                    </div>
                </div>
                <button *ngIf="!disabled && paramValue.view != 'true'" type="button" (click)="removeImage(i)"
                    class="absolute -top-2 -right-2 w-9 h-9 p-2 flex items-center justify-center rounded-full bg-[#3F41D1] border-[1.5px] border-white hover:bg-indigo-700 transition-colors">
                    <i class='bx bx-x text-white text-[20px] leading-none'></i>
                </button>
            </div>
        </div>

        <!-- Minimal File List -->
        <div *ngIf="uploaderVariant !== 'photo-box' && images.length > 0" class="flex flex-col gap-2">
            <div *ngFor="let img of images; let i = index" class="flex items-center justify-between py-1 p-4 bg-[#EBF2FF] border border-gray-200 rounded-lg shadow-md">
                <div class="flex items-center gap-3 overflow-hidden">
                    <!-- Preview Icon/Image -->

                    @if (accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp')) {
                    <img (click)="view_image(i)" *ngIf="accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp')" src="../../assets/Novamark_Image_Uploader.png" class="max-h-10 max-w-10 cursor-pointer object-cover">
                    }@else if(accept?.includes('pdf')) {
                    <img (click)="view_image(i)" class="cursor-pointer" src="../../../assets/PDF_File_Image.svg" alt="PDF File">
                    }@else {
                    <div (click)="view_image(i)" class="w-8 h-8 flex-shrink-0 rounded bg-gray-200 flex items-center justify-center overflow-hidden">
                        <i class='bx bx-file cursor-pointer text-gray-500 text-lg'></i>
                    </div>
                    }

                    <!-- File Info (Truncated) -->
                    <div class="flex flex-col min-w-0">
                        <span (click)="view_image(i)" class="text-sm font-medium cursor-pointer py-3 text-[#3F41D1] leading-none tracking-[0.02em] truncate block max-w-fit">
                            {{ (img?.split('/')?.pop()?.split('-')?.slice(1)?.join('-') || `Nova Mark ${lebal}` ) || 'Uploaded File ' + (i + 1) }}
                        </span>
                        <!-- <span class="text-[0.65rem] text-gray-500">
                            {{ imageSizes[i] || '' }}
                        </span> -->
                    </div>
                </div>

                <!-- Actions -->
                <div class="flex items-center gap-1">
                    <!-- <button type="button" (click)="view_image(i)" class="p-1 text-gray-400 hover:text-primary rounded-full hover:bg-blue-50 transition-colors">
                        <i class='bx bx-show text-lg'></i>
                    </button> -->
                    <!-- <button *ngIf="!disabled && paramValue.view != 'true'" (click)="removeImage(i)" class="p-1 text-gray-400 hover:text-red-500 rounded-full hover:bg-red-50 transition-colors">
                        <i class='bx bx-trash text-lg'></i>
                    </button> -->
                    <button type="button" *ngIf="!disabled && paramValue.view != 'true'" (click)="removeImage(i)" class="p-1 text-gray-400 rounded-full transition-colors">
                        <i class='bx bx-x text-red-500 text-2xl'></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- <p class="text-xs text-gray-500 -mt-1 italic">{{ sub_text }}</p> -->
    </div>
</div>
<div *ngIf="control && control.errors && (control.dirty || control.touched)" class="mt-1">
    <p class="text-xs text-red-500" *ngIf="control.errors.required">{{lebal}} is required.</p>
</div>